import React from 'react'

import { ThemeProvider } from '@mui/material'
import { getColorMode, getTheme } from 'themes'

import { TCustomization } from 'types/GlobalCustomization'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

interface LoadingProps {
  customization?: TCustomization
}

const Loading = (props: LoadingProps) => {
  const { customization } = props

  return (
    <>
      <ThemeProvider
        theme={getTheme(
          customization?.background_colors?.default
            ? getColorMode(customization?.background_colors?.default)
            : 'light'
        )}
      >
        <Box
          sx={{
            flex: '1 1 auto',
            minWidth: 0,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 2,
            bgcolor:
              customization?.background_colors?.default ?? 'background.paper'
          }}
        >
          {[1, 2, 3, 4].map((item) => (
            <Skeleton key={item} variant="rounded" height={256} />
          ))}
        </Box>
      </ThemeProvider>
    </>
  )
}

Loading.displayName = 'Loading'

export default Loading
